# Global options cache
options = {}

options.has = (key) ->
  options[key]?

export default options
